/*
 * Module for MemberDirect profile mfa details
*/

rs.module("content/user/profile/mfadetail",

    ["common/select-helper"],

    function (selectHelper) {

        //
        // Values and functions used by all initialize functions
        //

        // Equivalent of Guid.NewGuid()
        var defaultEntryKey = '00000000-0000-0000-0000-000000000000';

        // Show the a message after sending a new code
        var sendCodeMessageTimer;
        function _showCodeSentMessage(sendCodeButton, executedFunction) {

            executedFunction.done(function () {

                sendCodeButton.html("&#10003; Sent");

            }).fail(function () {

                sendCodeButton.html("Failed!");

            }).always(function () {

                // Each time a new code is sent, we want to reset the timeout for showing the sent message
                clearTimeout(sendCodeMessageTimer);

                // Hide the message after 2 seconds
                sendCodeMessageTimer = setTimeout(function () {

                    sendCodeButton.html("Send Code");
                }, 2000);
            });
        }

        // Send an Mfa code
        function _onSendCode(ajaxUrl, verificationType, verificationValueSelector, verificationEntryKey, successFunction, sendCodeButton) {

            // They just clicked send code, but don't proceed until we know the code was sent successfully.
            var executedCall = $.getJSON(ajaxUrl, { verificationType: verificationType, verificationValue: verificationValueSelector.val() }).done(function (data) {

                // Send the code and update the entrykey
                if (data.verificationCodeEntryKey != null && data.verificationCodeEntryKey != defaultEntryKey) {
                    verificationEntryKey.val(data.verificationCodeEntryKey);

                    if (successFunction != null) {
                        successFunction(data);
                    }
                }
                else {
                    // Something went wrong, a business error will arrive from the backend
                }
            });

            _showCodeSentMessage(sendCodeButton, executedCall);
        }

        //
        // Initialize for phone mfa detail
        //
        function initializePhone(
            jsSelectors,
            codeValues,
            ajaxUrl) {

            var mfaForm = $.js(jsSelectors.mfaForm);
            var phoneNumber = mfaForm.js(jsSelectors.phoneNumber);
            var phoneHidden = mfaForm.js(jsSelectors.phoneHidden);
            var sendCode = mfaForm.js(jsSelectors.sendCode);
            var verificationCode = mfaForm.js(jsSelectors.verificationCode);
            var verificationEntryKey = mfaForm.js(jsSelectors.verificationEntryKey);

            _checkPhoneNumber();

            phoneNumber.on("input", _checkPhoneNumber);
            function _checkPhoneNumber() {
                // Only enable send code if they're giving us a 10 digit phone
                var reg = new RegExp("^\\(?\\d{3}\\)?[\\ xs.-]*\\d{3}[\\s.x-]*\\d{4}$")

                if (!phoneNumber.val() || !reg.test(phoneNumber.val().trim())) {
                    sendCode.prop("disabled", true);
                }
                else {
                    sendCode.prop("disabled", false);
                }
            }

            // Grab the formatted phone number on success
            function onSuccess(data) {
                verificationCode.prop('readonly', false);
                verificationCode.removeClass('_code-disabled');


                phoneNumber.val(data.formattedPhone);
                phoneHidden.val(data.formattedPhone);
            }

            // Send a new verification code without changing any visuals
            sendCode.on("click", function () {
                _onSendCode(ajaxUrl, codeValues.SMS, phoneNumber, verificationEntryKey, onSuccess, sendCode);
            });
        }

        //
        // Initialize for email mfa detail
        //
        function initializeEmail(jsSelectors, codeValues, ajaxUrl) {

            var mfaForm = $.js(jsSelectors.mfaForm);
            var emailAddress = mfaForm.js(jsSelectors.emailAddress);
            var sendCode = mfaForm.js(jsSelectors.sendCode);
            var verificationCode = mfaForm.js(jsSelectors.verificationCode);
            var verificationEntryKey = mfaForm.js(jsSelectors.verificationEntryKey);

            function onSuccess(data) {
                verificationCode.prop('readonly', false);
                verificationCode.removeClass('_code-disabled');
            }

            sendCode.on("click", function () {
                _onSendCode(ajaxUrl, codeValues.Email, emailAddress, verificationEntryKey, onSuccess, sendCode);
            });
        }

        //
        // Initialize for the challenge questions detail
        //
        function initializeChallengeQuestions(jsSelectors) {

            var form = $.js(jsSelectors.form);

            var questionOne = form.js(jsSelectors.challengeQuestionSelect1, { required: false });
            var questionTwo = form.js(jsSelectors.challengeQuestionSelect2, { required: false });

            if (questionOne.length > 0) {

                // Disable selected questions in select lists when page loads
                disableSelectedQuestionInOtherList();

                // Disable question 1 in Question 2's select list
                questionOne.change(disableSelectedQuestionInOtherList);

                // Disable question 2 in Question 1's select list
                questionTwo.change(disableSelectedQuestionInOtherList);

                // Helper function to disable a selected question in the other question's select list
                function disableSelectedQuestionInOtherList() {
                    selectHelper.getHelper(questionOne).enableAllOptions().disableOptions([questionTwo.val()]);
                    selectHelper.getHelper(questionTwo).enableAllOptions().disableOptions([questionOne.val()]);
                }
            }
        }

        // Exported public API
        var exports = {
            initializeEmail: initializeEmail,
            initializePhone: initializePhone,
            initializeChallengeQuestions: initializeChallengeQuestions,
        };

        return exports;
    }
);